export default {
  eyebrow: 'Centrum nápovědy',
  title: 'Jak vám můžeme pomoci?',
  subtitle: 'Najděte odpovědi na časté otázky',
  search: {
    placeholder: 'Hledat v častých dotazech...',
  },
  noResults: 'Žádné výsledky pro „{query}“.',
  topics: {
    label: 'Témata',
    all: 'Vše',
    general: 'Obecné',
  },
  contact: {
    title: 'Potřebujete ještě pomoc?',
    body: 'Napište nám, a pokud máte číslo objednávky, uveďte ho.',
    emailSupport: 'Napsat podpoře',
  },

  sections: {
    purchasing: {
      title: 'Nákup a platba',
      items: [
        {
          q: 'Jak zaplatím pomocí peněženky?',
          a: [
            'Dobijte peněženku v sekci Účet → Platby a fakturace a poté zadejte objednávku z košíku. Celková částka objednávky se odečte z dostupného zůstatku.',
          ],
        },
        {
          q: 'Jaké způsoby platby pro dobití peněženky podporujete?',
          a: [
            'Dobití peněženky probíhá přes našeho platebního zprostředkovatele; aktuálně přijímané platební metody najdete v patičce. Údaje o vaší kartě se nikdy nedostanou na naše servery.',
          ],
        },
        {
          q: 'Proč mi platba selhala?',
          a: [
            'Nejčastější důvody: nedostatečný zůstatek, zamítnutí ověření 3-D Secure nebo nesoulad země s vydavatelem karty. Zkuste jinou kartu nebo kontaktujte podporu s číslem objednávky.',
          ],
        },
      ],
    },
    activation: {
      title: 'Aktivace klíče',
      items: [
        {
          q: 'Jak aktivuji klíč pro Steam?',
          a: [
            'Otevřete klienta Steam a přihlaste se ke svému účtu.',
            'Klikněte na nabídku „Hry“ v levém horním rohu a zvolte „Aktivovat produkt ve službě Steam…“',
            'Postupujte podle pokynů na obrazovce a vložte zakoupený klíč, až budete vyzváni.',
          ],
        },
        {
          q: 'Jak dlouho jsou klíče uloženy v mém účtu?',
          a: [
            'Klíče jsou viditelné na stránce detailu objednávky po dobu 24 hodin od doručení. Vždy vám je okamžitě zašleme i e-mailem — uložte si tento e-mail jako trvalý záznam.',
          ],
        },
        {
          q: 'Co mám dělat, když můj klíč nefunguje?',
          a: [
            'Kontaktujte podporu s číslem objednávky. Ověříme situaci u dodavatele a buď vám zašleme náhradní klíč, nebo vrátíme peníze do peněženky.',
          ],
        },
        {
          q: 'Mohu aktivovat klíče v různých regionech?',
          a: [
            'Každý produkt uvádí svůj region aktivace (např. EU, globální). Regionálně omezený klíč lze aktivovat pouze na účtech registrovaných v daném regionu. Pomocí filtrů v katalogu můžete výběr zúžit podle regionu.',
          ],
        },
      ],
    },
    account: {
      title: 'Správa účtu',
      items: [
        {
          q: 'Jak ověřím svůj e-mail?',
          a: [
            'Po registraci vám zašleme potvrzovací odkaz na zadanou adresu. Kliknutím na něj e-mail ověříte. Pokud odkaz vypršel, použijte možnost „Znovu odeslat ověřovací e-mail“ v přehledu účtu.',
          ],
        },
        {
          q: 'Co je KYC a kdy ho potřebuji?',
          a: [
            'KYC je ověření totožnosti. V souladu s předpisy EU je vyžadováno u jednotlivých nákupů nad 50 €. Své údaje odešlete v sekci Účet → Nastavení → Zabezpečení a ověření totožnosti.',
          ],
        },
        {
          q: 'Jak změním heslo?',
          a: [
            'Otevřete Účet → Nastavení → Heslo a zadejte stávající a nové heslo. Po změně hesla budou všechny ostatní relace odhlášeny.',
          ],
        },
        {
          q: 'Mohu smazat svůj účet?',
          a: [
            "Ano. Napište nám z e-mailové adresy registrované k účtu na support{'@'}keyzostore.com a požádejte o výmaz. Žádost vyřídíme do 14 dnů, jak vyžaduje GDPR.",
          ],
        },
      ],
    },
    refunds: {
      title: 'Vrácení peněz a reklamace',
      items: [
        {
          q: 'Jaké jsou podmínky vrácení peněz?',
          a: [
            'Klíče, které jste si ještě nezobrazili, lze kdykoli vrátit do peněženky. Jakmile si klíč zobrazíte, považuje se za použitý a je nevratný — s výjimkou vady na straně dodavatele.',
          ],
        },
        {
          q: 'Jak nahlásím vadný klíč?',
          a: [
            'Otevřete stránku objednávky a klikněte na „Nahlásit problém“. Uveďte chybové hlášení při aktivaci a pokud možno i snímek obrazovky. Problém předáme dodavateli do jednoho pracovního dne.',
          ],
        },
        {
          q: 'Jak dlouho trvá vrácení peněz?',
          a: [
            'Vrácení peněz do peněženky je okamžité. Vrácení zpět na původní způsob platby trvá 5–10 pracovních dnů v závislosti na vaší bance.',
          ],
        },
      ],
    },
  },
};
